import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent implements OnInit{
  @Input() columnHeader: any = [];
  @Input() tableData: any = [];
  @Input() distPoolPointsTableData:any = [];
  @Input() poolPointsTable:boolean = false;
  retroactive:string = "Retroactive adjustment";
  @Input() scrubberDaysTableData:any = [];
  @Input() scrubberDays:boolean = false;
  @Input() offHireOpdays:boolean = false;
  @Input() scrubberPoolPoints:boolean = false;
  @Input() scrubberPoolPointTableData:any = [];
  
  
  
  
  constructor(private datePipe:DatePipe) {}

  ngOnInit(): void {
    this.tableData = this.tableData?.map((item:any)=> (
      { ...item, 
        from: this.datePipe.transform(item?.from,'dd MMM yyyy HH:mm','UTC'), 
        to: this.datePipe.transform(item?.to,'dd MMM yyyy HH:mm','UTC'),
        reason: item?.reason ? (item?.reason?.[0]?.toUpperCase() + item?.reason?.slice(1)?.toLowerCase()) : null,
      }
    ));
    this.distPoolPointsTableData = this.distPoolPointsTableData?.map((item:any)=> ({...item,effectiveDate:this.datePipe.transform(item?.effectiveDate,'dd MMM yyyy HH:mm','UTC'),effectiveEndDate:this.datePipe.transform(item?.effectiveEndDate,'dd MMM yyyy HH:mm','UTC')}));
    this.scrubberDaysTableData = this.scrubberDaysTableData?.map((item:any)=> ({...item,delayFrmt:this.datePipe.transform(item?.delayFrmt,'dd MMM yyyy HH:mm','UTC'),delayToGmt:this.datePipe.transform(item?.delayToGmt,'dd MMM yyyy HH:mm','UTC')}));
    this.scrubberPoolPointTableData = this.scrubberPoolPointTableData?.map((item:any)=> ({...item,effectiveDate:this.datePipe.transform(item?.effectiveDate,'dd MMM yyyy HH:mm','UTC')}));
  }

}
